import React, { useEffect, useRef , useState} from "react";
import FormGroup from "../../fragments/form/FormGroup"

const GooglePlacesAutocomplete = ({ onPlaceSelected, ...props }) => {
    const [data, setData] = useState(props.value);
    const autocompleteRef = useRef(null);

    const onChange = (e) => {
        setData(e.target.value);
        props.onChange(props.id, e.target.value);
    }

    useEffect(() => {
        setData(props.value);
    }, [props.value]);


    useEffect(() => {
        let timeoutId = null;
        let isMounted = true;
        let retryCount = 0;
        const maxRetries = 50; // Maximum 5 seconds (50 * 100ms)

        const initAutocomplete = () => {
            if (!isMounted || !autocompleteRef.current) {
                return;
            }

            if (!window.google || !window.google.maps) {
                retryCount++;
                if (retryCount < maxRetries) {
                    // Retry after a short delay if Google Maps API is not loaded yet
                    timeoutId = setTimeout(() => {
                        initAutocomplete();
                    }, 100);
                } else {
                    console.error("Google Maps JavaScript API failed to load after multiple attempts.");
                }
                return;
            }

            const places = window.google.maps.places;

            if (!places) {
                retryCount++;
                if (retryCount < maxRetries) {
                    // Retry after a short delay if Places library is not loaded yet
                    timeoutId = setTimeout(() => {
                        initAutocomplete();
                    }, 100);
                } else {
                    console.error("Places library failed to load after multiple attempts.");
                }
                return;
            }

            // Clear any pending timeouts since we're initializing now
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }

            try {
                const autocomplete = new places.Autocomplete(autocompleteRef.current, {
                    componentRestrictions: { country: "ca" },
                });

                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    if (place && onPlaceSelected) {
                        onPlaceSelected(place);
                    }
                });
            } catch (error) {
                console.error("Error initializing Google Places Autocomplete:", error);
            }
        };

        // Check if script is already loaded
        const scriptTag = document.querySelector('script[src*="maps.googleapis.com"]');
        if (scriptTag && (scriptTag.getAttribute('data-loaded') === 'true' || (window.google && window.google.maps && window.google.maps.places))) {
            // Script is already loaded, initialize immediately
            initAutocomplete();
        } else if (scriptTag) {
            // Script exists but not loaded yet, wait for load event
            const handleLoad = () => {
                scriptTag.setAttribute('data-loaded', 'true');
                initAutocomplete();
            };
            scriptTag.addEventListener('load', handleLoad);
            // Also start polling as a fallback
            initAutocomplete();
            
            return () => {
                isMounted = false;
                scriptTag.removeEventListener('load', handleLoad);
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            };
        } else {
            // Script tag doesn't exist yet, start polling
            initAutocomplete();
        }

        return () => {
            isMounted = false;
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [onPlaceSelected]);

    return (
        <FormGroup {...props}>
            <input ref={autocompleteRef} type="text" required={props.required}  name={props.id} value={data} placeholder=""  onChange={onChange} className="form-control" />
        </FormGroup>
    )
};

export default GooglePlacesAutocomplete;
